module.exports = __webpack_public_path__ + "static/media/logo.87964a6f.png";